import { render } from "./NotifyComponent.vue?vue&type=template&id=1e09904e&scoped=true"
import script from "./NotifyComponent.vue?vue&type=script&lang=js"
export * from "./NotifyComponent.vue?vue&type=script&lang=js"

import "./NotifyComponent.vue?vue&type=style&index=0&id=1e09904e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e09904e"]])

export default __exports__